var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"video"}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$props.conteudo)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }